import { Box, TextField, Paper } from "@mui/material";
import { useContactCenterTheme } from "../../../virtual-receptionist/theming/ContactCenterThemeContext";
import { SenderButtons } from "./SenderButtons";
import { RecordingIndicator } from "./RecordingIndicator";
import { FilesGrid } from "../FilesGrid";
import { LoadingIndicator } from "./LoadingIndicator";

export const Composer = ({ composer }) => {
  const { theme } = useContactCenterTheme();
  const {
    message,
    setMessage,
    handleSend,
    isSendable,

    isRecording,
    startRecording,
    stopRecording,
    recordingTime,
    uploadingMessage,

    handleFileClick,
    handleImageClick,
    selectedFiles,
    selectedImages,
    handleRemoveFile,
    handleRemoveImage,
  } = composer;

  return (
    <Paper
      elevation={0}
      sx={{
        position: "relative",
        border: "1px solid",
        borderColor: theme.shell.border,
        borderRadius: 3,
        m: 1,
        overflow: "visible",
        flexShrink: 0,
        backgroundColor: theme.chat.inputBg,
        color: theme.shell.textPrimary,
      }}
    >
      {isRecording && <RecordingIndicator recordingTime={recordingTime} />}

      {(selectedFiles.length > 0 || selectedImages.length > 0) && (
        <FilesGrid
          selectedFiles={selectedFiles}
          selectedImages={selectedImages}
          onRemoveFile={handleRemoveFile}
          onRemoveImage={handleRemoveImage}
        />
      )}

      {uploadingMessage && <LoadingIndicator />}

      <Box px={1.5} pt={1}>
        <form onSubmit={handleSend} style={{ display: "flex", width: "100%" }}>
          <TextField
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            placeholder="Write a message..."
            variant="standard"
            multiline
            maxRows={4}
            fullWidth
            InputProps={{ disableUnderline: true }}
            onKeyDown={(event) => {
              if (event.key === "Enter" && !event.shiftKey) {
                event.preventDefault();
                handleSend();
              }
            }}
            sx={{
              "& .MuiInputBase-root": {
                fontSize: { xs: 15, sm: 14 },
                color: theme.shell.textPrimary,
              },
            }}
          />
        </form>
      </Box>

      <SenderButtons
        canSend={isSendable}
        uploadingMessage={uploadingMessage}
        isRecording={isRecording}
        onStartRecording={startRecording}
        onStopRecording={stopRecording}
        onSend={handleSend}
        onFileClick={handleFileClick}
        onImageClick={handleImageClick}
      />
    </Paper>
  );
};
